import React from "react";
import { WASidenavItemComponent } from "./WASidenavItemComponent";
import { Item } from "../VSETHNav/VSETHNavbar";
import { WASidenavToggleButton } from "./WASidenavToggleButton";
import { WASidenavNav } from "./WASidenavNav";
import { WASidenav } from "./WASidenav";
import { LinkConstructor } from "../../types";
import { Nav } from "../Nav/Nav";
interface Props {
  navItems: Item[];
  NavLink: LinkConstructor;
}
export const WASideNavDefault: React.FC<Props> = ({ navItems, NavLink }) => {
  return (
    <WASidenav>
      <WASidenavNav>
        <Nav>
          {navItems.map((item, i) => (
            <WASidenavItemComponent key={i} item={item} NavLink={NavLink} />
          ))}
        </Nav>
      </WASidenavNav>
      <WASidenavToggleButton />
    </WASidenav>
  );
};
